import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ProjectInfo } from '../_models/project-info';

export class UpdateProjectInfoAction {
  static readonly type = '[Project] Set Project Info';
  constructor(public payload: ProjectInfo) { }
}

// export class ProjectStateModel extends ProjectInfo {
// }

@State<ProjectInfo>({
  name: 'project',
  defaults: new ProjectInfo()
})
@Injectable()
export class ProjectState {

  @Selector()
  static currentProject(state: ProjectInfo): ProjectInfo {
    return state;
  }

  @Action(UpdateProjectInfoAction)
  updateProjectInfo(ctx: StateContext<ProjectInfo>, action: UpdateProjectInfoAction) {
    ctx.setState(action.payload);
  }
}
